import {
  ListItemIcon as MUIListItemIcon,
  ListItemIconProps,
} from '@mui/material';

export { type ListItemIconProps } from '@mui/material';

export function ListItemIcon(props: ListItemIconProps) {
  return <MUIListItemIcon {...props} />;
}
